import { render, staticRenderFns } from "./StoreFooter.vue?vue&type=template&id=175e8ccc&scoped=true"
import script from "./StoreFooter.vue?vue&type=script&lang=ts"
export * from "./StoreFooter.vue?vue&type=script&lang=ts"
import style0 from "./StoreFooter.vue?vue&type=style&index=0&id=175e8ccc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175e8ccc",
  null
  
)

export default component.exports